import React from 'react';

const MiniCard = ({ title, content, link, img, idx }) => {
    return (
        <div className='m-2 p-2'>
            <div className='inline-block md:flex m-2 px-2 max-w-sm text-center'>
                <div className='shrink-0 mx-4 flex place-content-center'>
                    <img
                        className='h-16 aspect-square rounded-full object-center '
                        src={img}
                        alt=''
                    />
                </div>
                <div>
                    <a
                        href={link}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-secondary font-bold text-xl'
                    >
                        {title}
                    </a>
                    <div dangerouslySetInnerHTML={{ __html: content }}>
                        {/* {content} */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniCard;
